/**
 * SSR（サーバーサイドレンダリング）実行中かどうかを返す。
 *
 * `import.meta.server` の直接参照だと vitest からテストできない
 * （ビルド時置換のため実行時に切り替え不能）ので、SSR/client で挙動が分岐する
 * ロジックはこの関数を経由し、テストでは vi.mock で差し替える（JCAT-5203）。
 */
export const isServerRendering = (): boolean => import.meta.server === true;
